// ----------------------------------------------------------------------------
// Component: Hero Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';

// Styles
import './_h1-plus-CTA.scss';
